interface Props {
  text?: string;
  colorClass?: string;
  className?: string;
  fontClass?: string;
}

export default function Heading({
  text,
  colorClass,
  fontClass,
  className,
}: Props) {
  return (
    <div
      className={`${fontClass ? fontClass : "font-bold text-2xl"} ${
        className ?? ""
      } ${colorClass ? colorClass : "text-black"}`}
    >
      {text || ""}
    </div>
  );
}
